import { useContext, type FC } from 'react';
import { ArrowIcon } from 'src/components/shared/elements/icons/ArrowIcon';
import { I18nContext } from 'src/stores/I18n';

type Props = {
  onClick: () => void;
  isExpanded: boolean;
};

export const ToggleButton: FC<Props> = ({ onClick, isExpanded }) => {
  const localeResources = useContext(I18nContext);
  return (
    <button onClick={onClick} className="flex gap-3 items-center justify-center">
      <span>{isExpanded ? localeResources.commons.foldContents : localeResources.commons.showMore}</span>
      <div className="flex items-center justify-center rounded-full border border-gray-300 border-solid w-5 h-5 p-1">
        <ArrowIcon direction={isExpanded ? 'top' : 'bottom'} />
      </div>
    </button>
  );
};
